import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteSingleReport } from 'Services';
import { RQ_ALL_REPORTS, RQ_SINGLE_REPORT } from 'Utils';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';

function useDeleteSingleReport(reportId: number | null) {
    const { addTechnicalErrorModal } = useReduxModal();
    const queryClient = useQueryClient();
    return useMutation([RQ_SINGLE_REPORT, reportId], () => deleteSingleReport(reportId!), {
        onSuccess: () => {
            queryClient.invalidateQueries([RQ_ALL_REPORTS]);
        },
        onError: (error: any) => {
            if (error?.status !== 400) {
                addTechnicalErrorModal();
            }
        }
    });
}

export default useDeleteSingleReport;
